import { render, staticRenderFns } from "./ProcessClouds.vue?vue&type=template&id=b4f37366"
var script = {}
import style0 from "./ProcessClouds.vue?vue&type=style&index=0&id=b4f37366&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports